import { shapes } from '@joint/plus';
import React, { ChangeEvent, ReactElement, useCallback, useState } from 'react';

import Input from '../Input/Input';
import { useBaseInspector } from './useBaseInspector';

interface Props {
    cell: shapes.app.Link;
}

const cellProps = {
    label: ['labels', 0, 'attrs', 'labelText', 'text']
};

const LinkInspector = (props: Props): ReactElement => {

    const { cell } = props;

    const [label, setLabel] = useState<string>('');

    const assignFormFields = useCallback((): void => {
        setLabel(cell.prop(cellProps.label));
    }, [cell]);

    const changeCellProp = useBaseInspector({ cell, assignFormFields });

    return (
        <>

            <label>Label
                <Input type="text"
                       placeholder="Enter label"
                       value={label}
                       onChange={(e: ChangeEvent<HTMLInputElement>) => changeCellProp(cellProps.label, e.target.value)}
                       disabled={true}
                />
            </label>
        </>
    );
};

export default LinkInspector;
